'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _appkitReact = require('appkit-react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _domHelper = require('../utils/domHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//theme priority:
// prop > localstorage > state

function getThemeInfo() {
  return parent.appkit_theme_notify_queue;
}

//ie does not have this function, implmenet our own
function getRootNode(node) {
  var result = node;

  while (result.parentNode) {
    result = result.parentNode;
  }

  return result;
}

function processThemeName(theme) {
  if (!theme) {
    return "";
  } else if (theme.startsWith && theme.startsWith("theme-")) {
    return theme;
  } else {
    return 'theme-' + theme;
  }
}

var ThemeContainer = function (_Component) {
  _inherits(ThemeContainer, _Component);

  function ThemeContainer(props) {
    _classCallCheck(this, ThemeContainer);

    var _this = _possibleConstructorReturn(this, (ThemeContainer.__proto__ || Object.getPrototypeOf(ThemeContainer)).call(this, props));

    _this.state = {
      theme: null
    };
    return _this;
  }

  _createClass(ThemeContainer, [{
    key: 'handleNotification',
    value: function handleNotification(info) {
      var theme = info.theme,
          level = info.level;

      var _theme = processThemeName(theme);

      if (_theme) {
        this.setState({
          theme: _theme
        });
      }

      if (level) {
        this.setState({
          level: level.toLowerCase()
        });
      }
    }
  }, {
    key: 'updateStoybookRoot',
    value: function updateStoybookRoot(theme, level) {
      if (this.props.isInStoryBook) {
        var storybookRoot = window.frameElement.getRootNode ? window.frameElement.getRootNode() : getRootNode(window.frameElement);

        storybookRoot = storybookRoot.getElementById("root");
        storybookRoot.setAttribute("theme", theme || this.getCurrentTheme());

        storybookRoot.setAttribute("level", level || this.getCurrentLevel());
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isInStoryBook) {
        this.uid = getThemeInfo().add(this.handleNotification.bind(this));

        var theme = getThemeInfo().currentTheme;
        var _theme = processThemeName(theme);
        var _level = getThemeInfo().currentLevel;

        this.handleNotification({ theme: _theme, level: _level });
        this.updateStoybookRoot(_theme, _level);
      }

      this.props.componentDidMountCallBack && this.props.componentDidMountCallBack();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateStoybookRoot();
      this.props.componentDidUpdateCallback && this.props.componentDidUpdateCallback();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.isInStoryBook) {
        getThemeInfo() && getThemeInfo().remove(this.uid);
      }

      this.props.componentWillUnmountCallBack && this.props.componentWillUnmountCallBack();
    }
  }, {
    key: 'getCurrentTheme',
    value: function getCurrentTheme() {
      return this.props.theme || this.state.theme || "";
    }
  }, {
    key: 'getCurrentLevel',
    value: function getCurrentLevel() {
      return this.props.level || this.state.level || "";
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          theme = _props.theme,
          componentDidUpdateCallback = _props.componentDidUpdateCallback,
          isInStoryBook = _props.isInStoryBook,
          level = _props.level,
          otherProps = _objectWithoutProperties(_props, ['className', 'children', 'theme', 'componentDidUpdateCallback', 'isInStoryBook', 'level']);

      var _theme = this.getCurrentTheme();
      var _level = this.getCurrentLevel();

      var wrapperClassName = (0, _classnames2.default)("a-theme-container", "100-height", className, {
        "is-inside-storybook": isInStoryBook
      });

      return _react2.default.createElement(
        'div',
        Object.assign({ className: wrapperClassName, theme: _theme, level: _level }, otherProps),
        children
      );
    }
  }]);

  return ThemeContainer;
}(_react.Component);

ThemeContainer.propTypes = {
  className: _propTypes2.default.string,
  componentDidUpdateCallback: _propTypes2.default.func,
  level: _propTypes2.default.oneOf(["level1", "level2", "level3"]),
  theme: _propTypes2.default.oneOf(["theme-dark", "theme-light"])
};

exports.default = ThemeContainer;